<template>
  <b-modal
    id="cancel-trip-modal"
    no-close-on-backdrop
    title="Cancel Trip"
  >
    Are you sure you want to cancel the trip {{ text }}
    <template #modal-footer="{cancel}">
      <div>
        <b-button
          variant="danger"
          class="mr-1"
          :disabled="submitting"
          @click="cancel"
        >
          Cancel
        </b-button>
        <b-button
          variant="primary"
          :disabled="submitting"
          @click="submit"
        >
          <b-spinner
            v-if="submitting"
            small
          />
          <span v-else>Confirm</span>
        </b-button>
      </div>
    </template>
  </b-modal>
</template>
<script>
import { BModal, BButton, BSpinner } from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import { errorNotification } from '@/utils/toast-notifications'

export default {
  components: {
    BModal,
    BSpinner,
    BButton,
  },
  props: {
    text: {
      type: String,
      required: true,
    },
    cancelCb: {
      type: Function,
      required: true,
    },
  },
  setup(props, ctx) {
    const submitting = ref(false)
    const submit = async () => {
      try {
        submitting.value = true
        await props.cancelCb()
        ctx.root.$bvModal.hide('cancel-trip-modal')
      } catch (err) {
        console.log(err)
        errorNotification('Something went wrong')
      } finally {
        submitting.value = false
      }
    }
    return { submit, submitting }
  },
}
</script>
